<svg [attr.width]="chartWidth" [attr.height]="chartHeight + 4">
	// The height of the viewport is smaller than its initial value, so adding a few more pixel to prevent line cropping
	<polyline [ngClass]="ngClassLine" #chartLine points="" fill="none" stroke-width="2" />
</svg>
